import Vue, { VNode } from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Button } from '../Button/Button';
import { Icon } from '../icon/Icon';
import { Tooltip } from '../Tooltip/Tooltip';

import './FileChooser.scss';

@Component({ name: 'FileChooser' })
class FileChooser extends Vue {
  private isLoading: boolean = false;
  private selectedFile: File | null = null;

  @Prop({ required: false, default: Button.Appearance.NORMAL })
  readonly buttonAppearance: Button.Appearance;

  @Prop({ required: false, default: Button.Color.LIGHT })
  readonly buttonColor: Button.Color;

  @Prop({ required: false, default: 'Choose File' })
  readonly buttonText: string;

  @Prop({ required: false, default: false })
  readonly disabled: boolean;

  @Prop({ required: false, default: false })
  readonly hasClear: boolean;

  $slots: {
    default: Array<VNode>;
  };

  render(): VNode {
    return (
      <div class="lp-file-picker">
        {this.renderContent()}
        <span class="file-input-wrapper">
          <Button
            text={this.buttonText}
            appearance={this.buttonAppearance}
            color={this.buttonColor}
            disabled={this.disabled}
            loading={this.isLoading}
          />
          <input type="file" class="file-input" disabled={this.disabled} title="" onChange={this.onUpload} />
        </span>
        {this.renderClearButton()}
      </div>
    );
  }

  private renderContent(): VNode | null {
    if (!this.$slots?.default) {
      return null;
    }

    return (
      <div class="file-input-content">
        {this.$slots.default}
      </div>
    );
  }

  private renderClearButton(): VNode | null {
    if (!this.hasClear || !this.selectedFile) {
      return null;
    }

    const buttonAppearance = (
      this.buttonAppearance !== Button.Appearance.OUTLINE
        ? Button.Appearance.LIGHTEN
        : Button.Appearance.OUTLINE
    );

    return (
      <Button
        class="file-input-clear"
        icon={Icon.Type.DELETE}
        appearance={buttonAppearance}
        color={Button.Color.DANGER}
        disabled={this.disabled}
        tooltip="Clear"
        tooltipPlacement={Tooltip.Placement.TOP}
        onClick={this.onClear}
      />
    );
  }

  private onUpload(e: MouseEvent): void {
    const button = e.target as HTMLInputElement;
    const file = button?.files?.[0] ?? null;

    if (file) {
      const reader = new FileReader();
      reader.onload = (event: ProgressEvent<FileReader>) => {
        const fileContent = event.target?.result;
        this.selectedFile = file;
        this.isLoading = false;
        this.$emit('change', file, fileContent);
      };
      this.isLoading = true;
      reader.readAsText(file);
    }
  }

  private onClear(e: MouseEvent): void {
    this.selectedFile = null;
    this.$emit('change');
  }
}

export { FileChooser };
